import React from "react";
import { string, func } from 'prop-types';

const TaskStatusFilter = ({ filter, onFilterSelect }) => {
  const buttons =
    [
      { name: 'all', label: 'Все' },
      { name: 'important', label: 'Важные' },
      { name: 'completed', label: 'Выполненные' },
    ]

  return (
    <div className="btn-group">
      {
        buttons.map(({ name, label }) => {
          const active = filter === name
          const cls = active ? 'btn-info' : 'btn-outline-secondary'

          return (
            <button
              key={name}
              type="button"
              className={`btn ${cls}`}
              onClick={() => onFilterSelect(name)}
            >
              {label}
            </button>
          )
        })
      }
    </div>
  )
}

TaskStatusFilter.propTypes = {
  filter: string,
  onFilterSelect: func,
}

TaskStatusFilter.defaultProps = {
  filter: 'all',
  onFilterSelect: () => { },
}

export default TaskStatusFilter